import { InfoBarMessageRank } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { ControlIcons } from 'owa-control-icons';

/**
 * get infoBar icon based on rank
 */
const getInfoBarIcon = (rank: InfoBarMessageRank) => {
    switch (rank) {
        case InfoBarMessageRank.SmimeSignature:
            return ControlIcons.Ribbon;
        case InfoBarMessageRank.Encryption:
            return ControlIcons.Encryption;
        case InfoBarMessageRank.Error:
            return ControlIcons.ErrorBadge;
        case InfoBarMessageRank.Translation:
            return ControlIcons.MicrosoftTranslatorLogo;
        default:
            return ControlIcons.Info;
    }
};

export default getInfoBarIcon;
